<template>
  <div class="page">
    <div class="page">
      <div class="locations-white locations-generic">
        <section>
          <div class="locations-title">Lake Tampier</div>
         <!-- <strong>Season: April - October</strong> -->
        </section>
        <section>
          <strong>Hours:</strong> Monday, Friday, Saturday, Sunday <br>
            9:00 a.m. until last rental, 6:00 p.m.<br>
     </section>
      <section>
        <strong>Boat Rentals:</strong>
        Kayaks, Canoes, and Row Boats.
      </section>
      <section>
        <strong>For Sale:</strong>
        Drinks, Snacks, Ice Cream, and Bait
      </section>
      <!-- <section>
        <strong>Events:</strong>
        Temporarily unavailable
      </section> -->
      <section>
        <strong>Minimum age and Weight:</strong>
        3 years, 35 lbs. (may be higher depending on water and weather
        conditions)
      </section>
        <a
          class="btn-primary btn"
          href="https://www.google.com/maps/dir/?api=1&destination=41.650169,-87.897741"
        >
          <strong>Directions</strong>
        </a>
      </div>
      <div class="locations-green locations-generic">
        <call-button tel-number="708-830-5194" />
        <br />131st and Wolf Road. Near Orland Park, IL.
      </div>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2981.2369383316195!2d-87.89769956474495!3d41.65062246416164!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880e41264396ec63%3A0x4136431c3183af5f!2sTampier%20Lake%20Boating%20Center!5e0!3m2!1sen!2sus!4v1588721362276!5m2!1sen!2sus"
        width="600"
        height="450"
        frameborder="0"
        style="border:0;"
        allowfullscreen=""
        aria-hidden="false"
        tabindex="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
import CallButton from "../CallButton";

export default {
  name: "LakeTampier",
  components: { CallButton },
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.call-button {
  color: white;
}
iframe {
  max-width: 90%;
}
.page {
  background-image: url("../../assets/TampierLakePic.jpg");
  background-size: 100%;
  flex-direction: column;
  padding-left: 20px;
}
section {
  margin-bottom: 10px;
}
</style>
